import {
    ICadastrarDevOps,
    ICommentsCardDevOps,
    IEditarDevOps,
    IGetBugCardDevOpsByIDCaso,
    IListHistoricoCardDevops,
    IResponseColumnsDevops,
    IResponseListFieldValues,
    IResultadoBuscaCardPorIdDevops,
} from "../../Interfaces/DevOps/DevOps";
import AxiosNewArchitecture from "../Config/ApiNewArchitecture";
import Service from "../Service";

export async function CadastrarBugsDevOpsService(
    ID_CASO: number,
    requestBody: ICadastrarDevOps
) {
    return Service(
        AxiosNewArchitecture.post(
            `/BugsDevOps/CreateBugCardDevOps?ID_CASO=${ID_CASO}`,
            requestBody
        )
    );
}

export async function EditarBugsDevOpsService(
    IdCaso: number,
    requestBody: IEditarDevOps
) {
    return Service(
        AxiosNewArchitecture.put(
            `/BugsDevOps/UpdateBugCardDevOps?IdCaso=${IdCaso}`,
            requestBody
        )
    );
}

export async function ListFieldValuesDevOpsService(field: string) {
    return Service(
        AxiosNewArchitecture.get<IResponseListFieldValues>(
            `/BugsDevOpsFields/ListFieldValues?field=${field}`
        )
    );
}

export async function GetBugCardDevOpsByIDCasoService(IdCaso: number) {
    return Service(
        AxiosNewArchitecture.get<IGetBugCardDevOpsByIDCaso>(
            `/BugsDevOps/GetBugCardDevOpsByIDCaso?IdCaso=${IdCaso}`
        )
    );
}

export async function SearchBugBoardColumnsDevOpsService() {
    return Service(
        AxiosNewArchitecture.get<IResponseColumnsDevops>(
            `/BugsDevOpsFields/SearchBugBoardColumnsDevOps`
        )
    );
}

export async function ListBugCardDevOpsService(requestBody: {
    pageNumber: number;
    itemsPerPage: number;
    flAtivo: boolean;
    idUsuario: number;
}) {
    return Service(
        AxiosNewArchitecture.post<Array<IGetBugCardDevOpsByIDCaso>>(
            `/BugsDevOps/ListBugCardDevOps`,
            requestBody
        )
    );
}

export async function AddCommentInDevOpsBugService(
    IdCardDevOps: number,
    requestBody: string
) {
    return Service(
        AxiosNewArchitecture.post<Array<IGetBugCardDevOpsByIDCaso>>(
            `/BugsDevOpsComment/AddCommentInDevOpsBug?IdCardDevOps=${IdCardDevOps}`,
            JSON.stringify(requestBody),
            {
                headers: { "Content-Type": "application/json" },
            }
        )
    );
}

export async function ListCommentInDevOpsBugService(IdCardDevOps: number) {
    return Service(
        AxiosNewArchitecture.get<Array<ICommentsCardDevOps>>(
            `/BugsDevOpsComment/ListCommentInDevOpsBug?IdCardDevOps=${IdCardDevOps}`
        )
    );
}

export async function UpdateCommentInDevOpsBugService(
    IdCardDevOps: number,
    IdCommentDevOps: number,
    requestBody: string
) {
    return Service(
        AxiosNewArchitecture.put(
            `/BugsDevOpsComment/UpdateCommentInDevOpsBug?IdCardDevOps=${IdCardDevOps}&IdCommentDevOps=${IdCommentDevOps}`,
            JSON.stringify(requestBody),
            {
                headers: { "Content-Type": "application/json" },
            }
        )
    );
}

export async function DeleteCommentInDevOpsBugService(
    IdCardDevOps: number,
    IdCommentDevOps: number
) {
    return Service(
        AxiosNewArchitecture.delete(
            `/BugsDevOpsComment/DeleteCommentInDevOpsBug?IdCardDevOps=${IdCardDevOps}&IdCommentDevOps=${IdCommentDevOps}`
        )
    );
}

export async function SearchUnlinkedBugCardsService(NrDevOpsCard: string) {
    return Service(
        AxiosNewArchitecture.get<IResultadoBuscaCardPorIdDevops>(
            `/BugsDevOps/SearchUnlinkedBugCards?NrDevOpsCard=${NrDevOpsCard}`
        )
    );
}

export async function LinkUnLinkBugCardsService(
    NrDevOpsCard: number,
    idCaso: number,
    flLinkCard: boolean
) {
    return Service(
        AxiosNewArchitecture.put(
            `/BugsDevOps/LinkUnLinkBugCards?NrDevOpsCard=${NrDevOpsCard}&idCaso=${idCaso}&flLinkCard=${flLinkCard}`
        )
    );
}

export async function ListCardHistoryBugDevopsService(idCardDevOps: number) {
    return Service(
        AxiosNewArchitecture.get<IListHistoricoCardDevops>(
            `/BugsDevOps/ListCardHistory?idCardDevOps=${idCardDevOps}`
        )
    );
}
